export class AuthenticationError extends Error {

    constructor(message: string, cause?: Error) {
        super(message);
        this.cause = cause;
    }

}
